export default function isEventInEditor(editor, event) {
  return editor.el && (editor.el === event.target || editor.el.contains(event.target));
}